export default "__VITE_ASSET__DXClPwUR__"